import React from "react";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { statusEnum } from "utils/enum";
import { ApiReport, endpoints_report } from "src/app/api/reportApi";
import { motion } from "framer-motion";
import FuseLoading from "@fuse/core/FuseLoading";
import { ApiUserAdmin, endpoints_supervisor } from "app/api/userAdminApi";
import { useSelector, useDispatch } from "react-redux";
import { selectUser } from "app/store/userSlice";
import { useLocation } from "react-router-dom";
import LocalSupervisorListItem from "./LocalSupervisorItem";

export default function LocalsSupervisorList() {
  const [locals, setLocals] = React.useState([]);
  const location = useLocation();
  const user = useSelector(selectUser);
  const api = new ApiUserAdmin();

  const getLocals = async () => {
    try {
      const response = await api.post(endpoints_supervisor.LOCALS, {
        supervisorId: user.data.id,
      });
      setLocals(response || []);
    } catch (error) {
      console.error("🚀 ~ getLocals ~ error:", error);
      setLocals([]);
    }
  };

  React.useEffect(() => {
    getLocals();
  }, [location]);

  if (!locals.length) {
    return <FuseLoading />;
  }

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex flex-col flex-auto w-full max-h-full space-y-4 px-4 sm:px-8"
    >
      <List className="w-full flex flex-col gap-2">
        {locals.map((local, key) => (
          <div key={key} className="relative">
            <Divider />
            <List className="w-full m-0 p-0">
              <LocalSupervisorListItem key={local.id} local={local} />
            </List>
          </div>
        ))}
      </List>
    </motion.div>
  );
}
